/* eslint-disable @typescript-eslint/no-unused-vars */

import { useNavigate } from "react-router-dom";
import { APP_CONSTANTS } from "../../constants";
import { idType } from "../../types";
import { SharedTable } from "../shared/tables/sharedTable";
import { tableAction, tableType as tableTypeE } from "../../enums";
import { useGetCentersQuery } from "../../store/api/centerApi";
import UpdateIcon from "../../assets/img/svg/updateIcon.svg";

interface ICentersListTableProps {}

/**
 *
 * @param props
 * @returns
 */
export const CentersTable = (props: ICentersListTableProps) => {
  const nav = useNavigate();

  /**
   *
   * @param userId
   */
  const onRowClick = (centerId: idType) => {};

  /**
   *
   */

  return (
    <SharedTable
      fetchHook={useGetCentersQuery}
      onRowClick={onRowClick}
      fetchSingleEntityHook={() => {}}
      tableType={tableTypeE.CENTERS}
      rowActions={[
        {
          name: tableAction.UPDATE_ROW,
          buttonText: "Modifier",
          buttonColor: "bg-[#50799E]",
          buttonIcon: UpdateIcon,
          handler: (centerId: idType) => {},
        },
      ]}
      isPaginated={true}
      tableHeaders={APP_CONSTANTS.TABLES.centers.headers}
      tableName={"Centers List"}
    />
  );
};
